import { render, staticRenderFns } from "./EUSubmissionFormView.vue?vue&type=template&id=b8e95462&"
import script from "./EUSubmissionFormView.vue?vue&type=script&lang=js&"
export * from "./EUSubmissionFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports